import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useDrawer = defineStore('drawer', () => {
  const visible = ref(false)
  const header = ref('')
  const content = ref<string[]>([]) // Array of strings for paragraphs

  const openDrawer = (newHeader: string, newContent: string[]) => {
    header.value = newHeader
    content.value = newContent
    visible.value = true
  }

  const closeDrawer = () => {
    visible.value = false
  }

  return { visible, header, content, openDrawer, closeDrawer }
})
